export const LOAD_SITES = "[nested-accounts] LOAD_SITES";
export const LOAD_AGGREGATED_EMISSIONS =
  "[nested-accounts] LOAD_AGGREGATED_EMISSIONS";
export const LOAD_GEO_SUBNATIONAL = "[nested-accounts] LOAD_GEO_SUBNATIONAL";
export const START_LOADING = "[nested-accounts] START_LOADING";
export const STOP_LOADING = "[nested-accounts] STOP_LOADING";
export const LOAD_CLIMATE_ACTIONS = "[nested-accounts] LOAD_CLIMATE_ACTIONS";
export const NESTED_ACCOUNTS_CLEAR_STATE =
  "[nested-accounts] NESTED_ACCOUNTS_CLEAR_STATE";
